"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _auth = require("@/api/auth");
var _vuePropertyDecorator = require("vue-property-decorator");
var RePasswordForm = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(RePasswordForm, _Vue);
  var _super = (0, _createSuper2.default)(RePasswordForm);
  function RePasswordForm() {
    var _this;
    (0, _classCallCheck2.default)(this, RePasswordForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetCode", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "email", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {
      password: {
        required: true,
        trigger: "sumbit"
      },
      cfPassword: {
        required: true,
        trigger: "sumbit",
        validator: _this.validatePassword
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showPass", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showConfirmPass", false);
    return _this;
  }
  (0, _createClass2.default)(RePasswordForm, [{
    key: "validatePassword",
    value: function validatePassword(rule, value, callback) {
      if (value != this.form.password) {
        return callback(new Error("Confirm password is not match"));
      }
      callback();
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      this.$router.replace("/auth");
      this.$emit("back");
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$refs.form.validate();
              case 2:
                this.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return _auth.authApi.reset({
                  resetCode: this.resetCode,
                  email: this.email,
                  password: this.form.password
                });
              case 6:
                res = _context.sent;
                this.$notify.success({
                  title: "Re-new Password",
                  message: "Successfully"
                });
                this.$router.replace("/auth");
                this.$emit("back");
              case 10:
                _context.prev = 10;
                this.loading = false;
                return _context.finish(10);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3,, 10, 13]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }]);
  return RePasswordForm;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], RePasswordForm.prototype, "resetCode", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], RePasswordForm.prototype, "email", void 0);
RePasswordForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({})], RePasswordForm);
var _default = RePasswordForm;
exports.default = _default;